import styled from 'styled-components';
import { always, cond, propEq, T } from 'ramda';

import { media } from '@theme/media';
import { CUSTOM_FIELDS, LAYOUT_L_OPTIONS } from '@modules/plp/plp.constants';

import { Item, List } from '../grid.styles';

export const GridList = styled(List)`
  flex-direction: column;
  align-items: center;
`;

const getItemWidth: (...rest: any) => any = cond([
  [propEq(CUSTOM_FIELDS.LAYOUT_L, LAYOUT_L_OPTIONS.p25), always('25%')],
  [propEq(CUSTOM_FIELDS.LAYOUT_L, LAYOUT_L_OPTIONS.p75), always('75%')],
  [propEq(CUSTOM_FIELDS.LAYOUT_L, LAYOUT_L_OPTIONS.p100), always('100%')],
  [T, always('50%')],
]);

export const GridItem = styled(Item)``;

export const GridItemWrapper = styled.div<{ [CUSTOM_FIELDS.LAYOUT_L]: string }>`
  width: 75%;
  padding: 0 10px 10px;
  margin: 0 auto;

  ${media.tablet} {
    width: ${getItemWidth};
    padding: 0 30px 80px;
  }
`;
